
// In variant thumbnail click in product acrt go to the product's page with the appropriate variant selected
document.querySelectorAll('.t4s-pr-color__item').forEach((el) => {
  el.addEventListener('click', (event) => {

    const productWrapper = el.closest('.t4s-product-wrapper');

    const hrefElement = productWrapper ? productWrapper.querySelector('[data-pr-href]') : null;

    if (hrefElement) {
      const originalHref = hrefElement.getAttribute('href');
      const url = new URL(originalHref, window.location.origin); 
      const dataVid = el.getAttribute('data-vid');

      url.searchParams.set('variant', dataVid);

      window.location.href = url.toString();
    } else {
      console.log('No element with data-pr-href found in the t4s-product-wrapper');
    }
  })
});
function getAllATCs () {
  document.querySelectorAll('[data-atc-form]').forEach((el) => {
    el.removeEventListener('click', () => stopCheckingForABit(event))
    el.addEventListener('click', () => stopCheckingForABit(event))
  });
}
getAllATCs()

function stopCheckingForABit () {
  localStorage.setItem('lunetteriegeneraleLastATC', new Date())
}

document.querySelectorAll('[data-action-quickview]').forEach((el) => {
    el.addEventListener('click', (event) => {
      setTimeout(() => {
        getAllATCs()
      }, 1000)
    })
});




jQuery_T4NT(document).ready(function ($) {

	initProductForm();
	window.changeImage2Injections = changeImage2Injections;

	$(document).on("modalt4s:opened", initProductForm);

	function initProductForm() {
		const productForm = document.querySelector('.js-product-form form');

		if (!productForm) {
			return null;
		}

		const url = window.location.href;
			const languagePattern = /\/([a-z]{2})\//;
			const match = url.match(languagePattern);

			if (match && match[1]) {
				let languagePrefix = match[1];
			}

		const preOrderStatus = languagePrefix && languagePrefix === "fr" ? "Pré-commande" : "Pre-order";
		const inStockStatus = languagePrefix && languagePrefix === "fr" ? "En stock" : "In stock";
		const stockStatusName = languagePrefix && languagePrefix === "fr" ? "Stock" : "Stock status";
		const expectedDeliveryName = languagePrefix && languagePrefix === "fr" ? "Livraison prévue" : "Expected delivery";
		const preorderValue = productForm.getAttribute('data-preorder');
		const preorderLineItems = `
			<input type="hidden" class="product-form-line-items" name="properties[${stockStatusName}]" value="${preOrderStatus}">
				  <input type="hidden" class="product-form-line-items" name="properties[${expectedDeliveryName}]" value="${preorderValue}">
		`;
		const inStockLineItems = `
			<input type="hidden" class="product-form-line-items" name="properties[${stockStatusName}]" value="${inStockStatus}">
		`;

		initVariantChangedHandler(productForm, preorderLineItems, inStockLineItems);
	}
	function changeImage2Injections(event) {
		// using this function in intractable.min.js
		const parentSelector = '.t4s-product-colors';
		const productCardSelector = '.t4s-product';
		const currentTarget = event[0];
		const parent = currentTarget.closest(parentSelector);
		const images2Data = parent.dataset.images2;
		
		if (!images2Data) return;
		const {variants} = JSON.parse(images2Data);
		const index = Array.from(parent.childNodes).indexOf(currentTarget);
		const newImage = variants[index];

		const cardEl = currentTarget.closest(productCardSelector);
		const imageEl = cardEl.querySelector('[data-pr-img2]');
		
		let widths;
		const dataWidths = imageEl.dataset.widths;
		if (dataWidths) widths = JSON.parse(dataWidths);
		
		if (newImage) {
			imageEl.dataset.srcset = getImageSet(newImage, widths);
			return;
		}

		// tmp solution, until we wait for sku in image alt tex
		const cardOptions = JSON.parse(cardEl.dataset.productOptions);
		const hoveredPicture = currentTarget.dataset.img;
		if (hoveredPicture === cardOptions?.image && cardOptions.image2) {
			imageEl.dataset.srcset = getImageSet(cardOptions.image2, widths);
			return;
		}
		//end of tmp solution

		imageEl.dataset.srcset = getImageSet(currentTarget.dataset.img, widths);
	}

	function getImageSet(imgUrl, widths) {
		if (!Array.isArray(widths) || typeof imgUrl !== 'string') return imgUrl;
		const variants = widths.map(width => `${imgUrl}&width=${width} ${width}w`).join(', ');
		return variants;
	}

	function initVariantChangedHandler(productForm, preorderLineItems, inStockLineItems) {
		$( document ).on( "variant:changed", function(evt) {
			const productForm = evt.target.querySelector('.js-product-form form');
			const formLineItems = productForm.querySelectorAll('.product-form-line-items');

			if (evt.currentVariant.available &&
				evt.currentVariant.inventory_quantity <= 0 &&
				evt.currentVariant.inventory_management === 'shopify'
			) {
				formLineItems?.forEach(item => item.remove());
				productForm.insertAdjacentHTML('afterbegin', preorderLineItems);
			} else {
				formLineItems?.forEach(item => item.remove());
				productForm.insertAdjacentHTML('afterbegin', inStockLineItems);
			}
		});
	}

    $(document).on("variant:changed", function (evt) {
        $('[data-variant-toggle]').hide(0);
        $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
    });

    let mobileBreakpoint = window.matchMedia("(max-width: 767px)");

    const changeAccordionPosition = function(event = mobileBreakpoint) {
		if (event.matches) {
			const tabs = document.querySelector(".t4s-product-tabs-wrapper");

			if (!tabs) return null;

			const rightCol = document.querySelector(".t4s-product__info-col.t4s-product__info-col--right");

			if (!rightCol) return null;

			tabs.parentNode.removeChild(tabs);
			rightCol.appendChild(tabs);
		} else {
			const tabs = document.querySelector(".t4s-product-tabs-wrapper");

			if (!tabs) return null;

			const leftCol = document.querySelector(".t4s-product__info-col.t4s-product__info-col--left");

			if (!leftCol) return null;

			tabs.parentNode.removeChild(tabs);
			leftCol.appendChild(tabs);
		}
    }

	mobileBreakpoint.addEventListener("change", changeAccordionPosition);
	changeAccordionPosition();
});